export default __webpack_public_path__ + "static/media/Apple iPad Pro 10.5.e6532f16.png";